import React from "react"

function Plan() {
  const planData = {
    fileName: "Plan (test).plan",
    date: "12/10/2025, 11:25:30 AM",
    fileId: 419,
  }

  const handleDownload = () => {
    // Handle download action
    console.log("Download plan")
  }

  const handleView = () => {
    // Handle view action
    console.log("View plan")
  }

  return (
    <div id="plan-wrapper" className="w-full mb-2 px-6 py-4 bg-white dark:bg-gray-900 rounded-md">
      <div id="plan-container" className="w-full">
        <div id="plan-content" className="relative">
          <div id="plan-header" className="mb-2">
            <h2 className="font-semibold text-md text-gray-900 dark:text-gray-100">Plan</h2>
          </div>
          <div id="plan-body" className="flex flex-col w-full text-center items-center">
            <div id="plan-file-info" className="relative w-full">
              <div id="plan-file-display" className="flex select-none w-full rounded-md bg-gray-100 dark:bg-gray-800 dark:bg-gray-900 rounded-lg">
                <div id="plan-file-icon-container" className="p-1">
                  <div
                    id="plan-file-icon"
                    className="flex flex-col overflow-hidden shadow-md transition-all duration-200 hover:shadow-lg"
                    style={{ width: "30px", height: "auto", borderRadius: "6px" }}
                  >
                    <div
                      id="plan-icon-top"
                      className="flex items-center justify-center w-full bg-white dark:bg-gray-900"
                      style={{
                        height: "24px",
                        padding: "3px",
                        backgroundColor: "rgb(222, 222, 222)"
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#D32F2F"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-calendar bg-transparent"
                      >
                        <path d="M8 2v4"></path>
                        <path d="M16 2v4"></path>
                        <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                        <path d="M3 10h18"></path>
                      </svg>
                    </div>
                    <div
                      id="plan-icon-label"
                      className="w-full flex items-center justify-center"
                      style={{
                        height: "12px",
                        backgroundColor: "rgb(211, 47, 47)"
                      }}
                    >
                      <span
                        id="plan-label-text"
                        className="text-center font-medium"
                        style={{
                          color: "rgb(232, 232, 232)",
                          width: "100%",
                          justifyContent: "center",
                          alignItems: "center",
                          fontSize: "6.75px"
                        }}
                      >
                        PLAN
                      </span>
                    </div>
                  </div>
                </div>
                <div id="plan-file-details" className="flex flex-col justify-center text-left ml-2">
                  <p id="plan-file-name" className="text-sm font-medium text-gray-800">
                    {planData.fileName}
                  </p>
                  <p id="plan-file-date" className="text-xs text-gray-500">
                    {planData.date}
                  </p>
                </div>
                <div id="plan-file-actions" className="flex-grow flex justify-end items-center pr-2">
                  <div id="plan-download-action" className="mr-2">
                    <div
                      id="plan-download-button"
                      className="cursor-pointer flex justify-between relative rounded-md overflow-hidden group relative hover:bg-gradient-to-r hover:from-gray-200 hover:to-gray-50 hover:ring-2 hover:ring-offset-2 hover:ring-gray-600 transition-all ease-out duration-300 cursor-pointer hover:bg-gray-200 dark:bg-gray-800 text-gray-500 p-2 rounded-md w-full"
                      onClick={handleDownload}
                    >
                      <span className="absolute right-0 w-8 h-32 -mt-12 transition-all duration-500 transform translate-x-12 bg-gray-400 opacity-10 rotate-12 group-hover:-translate-x-40 ease"></span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-download h-5 w-5"
                      >
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                        <polyline points="7 10 12 15 17 10"></polyline>
                        <line x1="12" x2="12" y1="15" y2="3"></line>
                      </svg>
                    </div>
                  </div>
                  <div id="plan-view-action" className="mr-2">
                    <div
                      id="plan-view-button"
                      className="cursor-pointer flex justify-between relative rounded-md overflow-hidden group relative hover:bg-gradient-to-r hover:from-gray-200 hover:to-gray-50 hover:ring-2 hover:ring-offset-2 hover:ring-gray-600 transition-all ease-out duration-300 cursor-pointer hover:bg-gray-200 dark:bg-gray-800 text-gray-500 p-2 rounded-md w-full"
                      onClick={handleView}
                    >
                      <span className="absolute right-0 w-8 h-32 -mt-12 transition-all duration-500 transform translate-x-12 bg-gray-400 opacity-10 rotate-12 group-hover:-translate-x-40 ease"></span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-eye h-5 w-5"
                      >
                        <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path>
                        <circle cx="12" cy="12" r="3"></circle>
                      </svg>
                    </div>
                  </div>
                  <a id="plan-folder-link" href={`/file/${planData.fileId}`} className="mr-2">
                    <div
                      id="plan-folder-button"
                      className="cursor-pointer flex justify-between relative rounded-md overflow-hidden group relative hover:bg-gradient-to-r hover:from-gray-200 hover:to-gray-50 hover:ring-2 hover:ring-offset-2 hover:ring-gray-600 transition-all ease-out duration-300 hover:bg-gray-200 dark:bg-gray-800 text-gray-500 p-2 rounded-md w-full"
                    >
                      <span className="absolute right-0 w-8 h-32 -mt-12 transition-all duration-500 transform translate-x-12 bg-gray-400 opacity-10 rotate-12 group-hover:-translate-x-40 ease"></span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-folder-symlink h-5 w-5"
                      >
                        <path d="M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7"></path>
                        <path d="m8 16 3-3-3-3"></path>
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Plan

